import instance from "../Service";

export default class Bills {
  static async get_bills_operations_data() {
    return await instance.get("/bills/get_bills_operations_data");
  }
}
